import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { AuthTypeComponent } from '../auth-type.shared.component';

@Component({
    selector: 'shared-auth-for-rewards-account-linking-sign-up',
    templateUrl: './auth-for-rewards-account-linking-sign-up.shared.component.html',
    styleUrls: ['./auth-for-rewards-account-linking-sign-up.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthForRewardsAccountLinkingSignUpComponent extends AuthTypeComponent {
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
    ) {
        super(controllers);
    }

    public get title(): string {
        return this.config.signUpRewardsAccountLinking?.headerText || null;
    }

    public get description(): string {
        return this.config.signUpRewardsAccountLinking?.descriptionText || null;
    }
}
